var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbSelectInput',{attrs:{"options":_vm.ruleOptions,"id":'condition_name-' + _vm.conditionIndex,"name":_vm.$t('shippingRulesPage.newRuleTab.newCondition'),"required":""},on:{"change":_vm.resetCondition},model:{value:(_vm.conditionName),callback:function ($$v) {_vm.conditionName=$$v},expression:"conditionName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }